import { fetchData } from './fetchData';
import { Partner } from '../data/Partner';

export type ResPartnerRequestData = {
    line_uid: string,
    login: string,
};

/**
 * @description LINE ID與帳號擇一傳入,不可模糊查詢
 */
function resPartner(data: ResPartnerRequestData): Promise<Partner> {
    return fetchData('api/res_partner', {
        method: 'POST',
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((resData: Partner) => resData);
}

export { resPartner };
